export default __webpack_public_path__ + "static/media/delivery-car-image.69a25e26.png";